import React, { useState } from 'react';
import { Button, Modal, Typography } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import Message from '../../../../config/Message';
import { Notification } from '../../../../config/Global';
const { Title } = Typography;

const DeleteMerchantComponent = observer((props) => {
	const { visible, onClose } = props;
	const [saving, setSaving] = useState();
	const { ACCOMMODATION } = useStore();
	//const { propertyDetail, roomCategoryDetail } = ACCOMMODATION;
	const deleteChangeMerchant = () => {
		setSaving(true);

		let merchantPayload = {
			id: visible.id.toString(),
			versionNo: visible.versionNo,
		};
		ACCOMMODATION.deleteMerchant({
			...merchantPayload,
		})
			.then((msg) => {
				Notification.success({
					message: Message().CRUD.DELETE(
						'Merchant, Property and Room Category'
					),
				});
				onClose();
			})
			.catch((e) => {
				Notification.error({
					message: 'Something Wrong',
				});
			})
			.finally(() => setSaving(false));
	};

	return (
		<Modal
			title="Delete Merchant"
			onCancel={onClose}
			open={visible}
			destroyOnClose
			width={'450px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						loading={saving}
						onClick={deleteChangeMerchant}
					>
						Delete
					</Button>
					<Button key={2} onClick={onClose}>
						Cancel
					</Button>
				</div>
			}
		>
			<Title level={5}>
				Are you sure you want to
				<b>
					{' '}
					delete
					{' ' + visible?.merchantName + ' '}
				</b>
				merchant?
			</Title>
		</Modal>
	);
});

export default DeleteMerchantComponent;
